var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g({staticClass:"ui-item",class:[_vm.tone && `ui-item--${_vm.tone}`, _vm.branch && 'ui-item--branch', { 'is-on': _vm.active }],attrs:{"type":"button"}},_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }